import React, { useEffect, useState } from 'react';
import '../../CSS/Global.css';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';

const CallToActionTable = () => {
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const token = decryptToken("accessToken") || ""
    const url = process.env.REACT_APP_LINK;
    const [slider, setSlider] = useState([])
    const [load, setLoad] = useState(false);
    const sliderFetch = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/calltoaction-form/all`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            const res = await response.json();;
            setSlider(res);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false)
        }
    }

    // Mock testimonials data
    const mockTestimonials = [
        {
            productName: "Wireless Headphones",
            customerName: "Alice Johnson",
            testimonialTitle: "Amazing sound quality!",
            starRating: 5,
            submittedAt: "2025-09-05 14:20",
        },
        {
            productName: "Smart Watch",
            customerName: "Bob Williams",
            testimonialTitle: "Great features but battery could be better",
            starRating: 4,
            submittedAt: "2025-09-06 10:45",
        },
        {
            productName: "Gaming Mouse",
            customerName: "Charlie Brown",
            testimonialTitle: "Responsive and comfortable",
            starRating: 5,
            submittedAt: "2025-09-07 18:30",
        },
        {
            productName: "Bluetooth Speaker",
            customerName: "Diana Prince",
            testimonialTitle: "Compact but powerful",
            starRating: 4,
            submittedAt: "2025-09-08 09:15",
        },
        {
            productName: "Laptop Stand",
            customerName: "Ethan Hunt",
            testimonialTitle: "Solid build, good angle",
            starRating: 5,
            submittedAt: "2025-09-09 20:05",
        },
    ];

    const [testimonialData, setTestimonialData] = useState(slider);

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;
    const totalPages = Math.ceil(slider.length / rowsPerPage);

    const paginatedData = slider.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    // Helper: render stars
    const renderStars = (count) => "★".repeat(count) + "☆".repeat(5 - count);


    useEffect(() => {
        sliderFetch();
    }, [])
    return (
        <>
            <div >
                <div className="oms-header">
                    <h1 className="dashboard-title">Request Callback</h1>
                    
                </div>

                {/* Desktop Table */}
                <div className="customer-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>User</th>
                                <th>Mobile</th>
                                <th>Description</th>
                                <th>Submitted At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.length > 0 ? (
                                paginatedData.map((row, i) => (
                                    <tr key={i}>
                                        <td>{row.name}</td>
                                        <td>{row.user_name ||""}</td>
                                        <td>{row.mobile ||""}</td>
                                        <td>{row.description ||""}</td>
                                        <td>
                                            {new Date(row.createdAt).toLocaleString("en-IN", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No testimonials yet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Mobile Cards */}
                <div className="ecom-responsive-cards">
                    {paginatedData.length > 0 ? (
                        paginatedData.map((row, i) => (
                            <div className="ecom-responsive-card" key={i}>
                                <div className="ecom-responsive-header">
                                    <p>
                                        <strong className='mr-1'>Submitted At:</strong> {row.submittedAt}
                                    </p>
                                </div>
                                <div className="ecom-responsive-body">
                                    <p>
                                        <strong>Product:</strong> {row.productName}
                                    </p>
                                    <p>
                                        <strong>Customer:</strong> {row.customerName}
                                    </p>
                                    <p>
                                        <strong>Testimonial:</strong> {row.testimonialTitle}
                                    </p>
                                    <p>
                                        <strong>Rating:</strong> {renderStars(row.starRating)}
                                    </p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p style={{ textAlign: "center", margin: "50px" }}>
                            No testimonials yet
                        </p>
                    )}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => handlePageChange(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>
                        <button className="pagination-btn active">{currentPage}</button>
                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>
                        <button
                            onClick={() => handlePageChange(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}
            </div>
            
        </>
    );
};

export default CallToActionTable;
